import { render } from "./ArtboardPanel.vue?vue&type=template&id=19413e9b&scoped=true&ts=true"
import script from "./ArtboardPanel.vue?vue&type=script&lang=ts"
export * from "./ArtboardPanel.vue?vue&type=script&lang=ts"

import "./ArtboardPanel.vue?vue&type=style&index=0&id=19413e9b&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/apps/builder-legacy/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19413e9b"]])

export default __exports__